<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Preparar Solicitud</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
            <div class="row" style="margin-top:20px">
              <div class="col-2">
                <router-link :to="{ name: 'DetalleSolicitudEvaluacion', params: {idSolicitud: idSolicitud } }">
                  <button type="button" class="form-control btn-sm btn-custom"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
                </router-link>
              </div>
            </div>
          <div class="row" style="margin-top:20px">
            <div class="col-5">
              <h5><span class="label label-default label-black">Persona a Evaluar</span></h5>
            </div>
          </div>
          <div class="row" style="margin-top:30px;">
            <div class="col-4">
              <span class="label label-default label-black">ID Evaluado</span>
            </div>
            <div class="col-4">
              <span class="label label-default label-black">Nombre</span>
            </div>
            <div class="col-4">
              <span class="label label-default label-black">Tipo Puesto</span>
            </div>
          </div>
          <div class="row" style="margin-top:10px;">
            <div class="col-4">
              <input type="text" class="form-control" v-model="idEvaluadoPeriodo" readonly />
            </div>
            <div class="col-4">
              <input type="text" class="form-control" value="Juan José Sánchez" v-model="nombreEvaluadoPeriodo" readonly />
            </div>
            <div class="col-4">
              <input type="text" class="form-control" value="Base" v-model="tipoPuestoPeriodo" readonly />
            </div>
          </div>
          <div class="row">
            <div class="col-12"><hr /></div>
          </div>
          <div class="row" style="margin-top:20px;">
            <div class="col-5">
              <h5><span class="label label-default label-black">Historial Laboral</span></h5>
            </div>
          </div>
          <div class="row table-responsive" style="margin-top:10px;">
            <div class="col-12 ">
              <table class="table table-striped table-light table-hover table-sm" id="tablaHistorial">
                <thead class="thead-custom">
                  <tr>
                    <th></th>
                    <th>Tipo Puesto</th>
                    <th>Periodo</th>
                    <th>Departamento</th>
                    <th>Sección</th>
                    <th>Puesto</th>
                  </tr>
                </thead>
                <tbody class='text-dark'>
                  <tr v-for='(registro,indice) in infoHistorialLaboral'>
                    <td><input type='radio' name='periodo' @click='cargarFechas(registro.FechaInicial,registro.FechaFinal,indice+1)'></td>
                    <td>{{ registro.TipoContrato }}</td>
                    <td>{{registro.Periodo}}</td>
                    <td>{{registro.Departamento}}</td>
                    <td>{{registro.Seccion}}</td>
                    <td>{{registro.Puesto}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row" style="margin-top:20px;">
            <div class="col-5">
              <h5><span class="label label-default label-black">Periodo a Evaluar</span></h5>
            </div>
          </div>
          <div class="row" style="margin-top:20px;">
            <div class="col-3">
              <span class="label label-default label-black">Fecha Inicial:</span>
            </div>
            <div class="col-3">
              <span class="label label-default label-black">Fecha Final:</span>
            </div>
            <div class="col-3">
              <span class="label label-default label-black">Fecha Límite de Entrega:</span>
            </div>
          </div>
          <div class="row" style="margin-top:20px;">
            <div class="col-3">
              <input type="date" class="form-control" id="fechaInicial" v-model="fechaInicial" required>
            </div>
            <div class="col-3">
              <input type="date" class="form-control" id="fechaFinal" v-model="fechaFinal" required>
            </div>
            <div class="col-3">
              <input type="date" class="form-control" id="fechaLimite" v-model="fechaLimite" required>
            </div>
            <div class="col-3">
              <input type="button" class="form-control btn-sm btn-custom" value="Asignar Periodo" v-bind:disabled="deshabilitarBotonPeriodo" @click="EditarPeriodoEvaluacion">
            </div>
          </div>

          <!-- <div class="row" style="margin-top:20px;">
            
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div slot="main">
      <div class="container-fluid" style="margin-top:30px;">
        <div class="row" style="margin-top:20px">
          <div class="col-2">
            <router-link :to="{ name: 'DetalleSolicitudEvaluacion', params: {idSolicitud: idSolicitud } }">
              <button type="button" class="form-control"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
            </router-link>
          </div>
        </div>
        <div class="row" style="margin-top:20px">
          <div class="col-5">
            <h5><span class="label label-default">Persona a Evaluar</span></h5>
          </div>
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-3">
            <span class="label label-default">ID Evaluado</span>
          </div>
          <div class="col-3">
            <span class="label label-default">Nombre</span>
          </div>
          <div class="col-3">
            <span class="label label-default">Tipo Puesto</span>
          </div>
        </div>
        <div class="row" style="margin-top:10px;">
          <div class="col-3">
            <input type="text" class="form-control" v-model="idEvaluadoPeriodo" readonly />
          </div>
          <div class="col-3">
            <input type="text" class="form-control" value="Juan José Sánchez" v-model="nombreEvaluadoPeriodo" readonly />
          </div>
          <div class="col-3">
            <input type="text" class="form-control" value="Base" v-model="tipoPuestoPeriodo" readonly />
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-5">
            <h5><span class="label label-default">Historial Laboral</span></h5>
          </div>
        </div>
        <div class="row" style="margin-top:10px;">
          <div class="col-10">
            <table class="table table-striped table-light table-hover" id="tablaHistorial">
              <thead class="thead-custom">
                <tr>
                  <th></th>
                  <th>Tipo Puesto</th>
                  <th>Periodo</th>
                  <th>Departamento</th>
                  <th>Sección</th>
                  <th>Puesto</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='(registro,indice) in infoHistorialLaboral'>
                  <td><input type='radio' name='periodo' @click='cargarFechas(registro.FechaInicial,registro.FechaFinal,indice+1)'></td>
                  <td>{{ registro.TipoContrato }}</td>
                  <td>{{registro.Periodo}}</td>
                  <td>{{registro.Departamento}}</td>
                  <td>{{registro.Seccion}}</td>
                  <td>{{registro.Puesto}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-5">
            <h5><span class="label label-default">Periodo a Evaluar</span></h5>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <span class="label label-default">Fecha Inicial:</span>
          </div>
          <div class="col-3">
            <span class="label label-default">Fecha Final:</span>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <input type="date" class="form-control" id="fechaInicial" v-model="fechaInicial" required>
          </div>
          <div class="col-3">
            <input type="date" class="form-control" id="fechaFinal" v-model="fechaFinal" required>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <span class="label label-default">Fecha Límite de Entrega:</span>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <input type="date" class="form-control" id="fechaLimite" v-model="fechaLimite" required>
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-6">
            <input type="button" class="form-control" value="Asignar Periodo" v-bind:disabled="deshabilitarBotonPeriodo" @click="EditarPeriodoEvaluacion">
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'

  export default {
    props: ['idEvaluacion', 'idSolicitud'],//Recibe como parametro el id de evaluación
    //Recibe el id de Solicitud a editar
    data() {
      return {
        
        idEvaluadoPeriodo: null,//Indica el id del evaluado al cual se le está asignando un periodo de evaluación
        nombreEvaluadoPeriodo: null,//Indica el nombre del evaluado al cual se le está asignando un periodo de evaluación
        tipoPuestoPeriodo: null,//Indica el tipo de contrato del evaluado al cual se le está asignando un periodo de evaluación
        fechaInicial: null,//Almacena la fecha inicial del periodo de evaluación del evaluado
        fechaFinal: null,//Almacena la fecha final del periodo de evaluación del evaluado
        fechaLimite: null,//Almacena la fecha limite de evaluación del evaluado       
        indice: 0,//Indica el indice del periodo seleccionado para evaluación        
        infoHistorialLaboral: []
      }
    },
    components: {
      //Layout
    },
    methods: {
      ///busca a traves de axios los posibles evaluados almacenados en base de datos
      GetEvaluacion: function () {
        var peticion = {
            //Carga la información para la petición
            "esPrueba": false,
            "idEvaluacion": this.idEvaluacion
        };
        comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.SISEVA.funcion.GetEvaluacion, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
            if (response.data.SiHayError == false) {
              //console.log(response.data)
              this.idEvaluadoPeriodo = response.data.evaluacion.EvaluadoId
              this.nombreEvaluadoPeriodo = response.data.evaluacion.nombreEvaluado
              this.tipoPuestoPeriodo = response.data.evaluacion.TipoContrato
              //this.fechaInicial = 
              this.fechaInicial = moment(response.data.evaluacion.FechaInicioPeriodoEvaluacion).format('YYYY-MM-DD');
              this.fechaFinal = moment(response.data.evaluacion.FechaFinPeriodoEvaluacion).format('YYYY-MM-DD');
              this.fechaLimite = moment(response.data.evaluacion.FechaLimiteEntrega).format('YYYY-MM-DD');
              
              this.mostrarHistorialLaboral();
            }
            else {
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            }
            comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error " + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
       EditarPeriodoEvaluacion: function () {
        var peticion = {
            //Carga la información para la petición
            "esPrueba": false,
            "EvaluacionId": this.idEvaluacion,
            "FechaInicioPeriodo": this.fechaInicial,
            "FechaFinPeriodo": this.fechaFinal,
            "FechaLimite": this.fechaLimite,
        };
        comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.SIAP.funcion.EditarPeriodoEvaluacion, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
            if (response.data.SiHayError == false) {
              comun.mensajeDeAlerta("Fechas modificadas exitosamente.",null,null)
            }
            else {
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            }
            comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error " + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
        mostrarHistorialLaboral: function () {//Muestra el historial laboral del evaluado
          this.indice = 0
          var peticion = {
            //Carga la información para la petición
            "esPrueba": false,
            "IdPersona": this.idEvaluadoPeriodo
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.SIAP.funcion.GetHistorialLaboral2, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
            if (response.data.SiHayError == false) {
              this.infoHistorialLaboral = response.data.InfoHistorialLaboral
              this.$nextTick(() => {
                PaginarTabla('tablaHistorial', 3)
              })
              $("input:radio").attr("checked", false);
            }
            else {
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            }
            comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error " + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      }, cargarFechas: function (fechaInicial, fechaFinal, indice) {//Inserta las fechas inicial y final en la sección de asignación de periodo de evaluación al momento de seleccionar un periodo laboral
        this.fechaInicial = fechaInicial
        if (moment(fechaFinal, "YYYY-MM-DD", true).isValid()) {//Verifica que la fecha final sea valida antes de insertarla
          this.fechaFinal = fechaFinal
        }
        this.indice = indice//Actualiza el valor del indice de periodo laboral
      }
      

    }, computed: { // Indica si el boton de asignar periodo deberia estar deshabilitado en base a si las fechas están capturadas y se ha seleccionado un periodo laboral
      deshabilitarBotonPeriodo: function () {
        return this.fechaInicial == null || this.fechaFinal == null || this.fechaLimite == null
      }
    }
    , mounted: function () {
      
        this.GetEvaluacion()//carga la información de la solicitud de evaluaciones
      
    }

  }
</script>
<style scoped>
  a {
    color: #fff;
  }

  input[type="text"]:read-only {
    background: #f3f3f3;
  }

  input[type="text"]:read-only:focus {
    color: #fff;
  }
  .thead-custom {
  background-color: #004746;
  color: white;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/EditarPeriodoEvaluacion.vue